<template>
	<div class="flex-container course-sections-flex">
		<div class="class-nav-item" v-if="showHomeSection">
			<a @click.prevent="goToHome" href="#" :disabled="isClassHome" :class="{'class-nav-item-disabled': isClassHome}">
				<page-icon v-bind="homeIconProps"></page-icon>
				<span class="title">{{$t('MAIN_CONTENT.classPage.ClassNav.classPage_classHome')}}</span>
			</a>
		</div>
		<div class="class-nav-item" v-for="( item, itemIdx ) in menu" :key="'menu-item-' + itemIdx">
			<a @click.prevent="goToSection(item.FOLDER_ID)" href="#" :disabled="currentSection === item.FOLDER_ID" :class="{'class-nav-item-disabled': currentSection === item.FOLDER_ID}">
				<page-icon 
					:text="item.FOLDER_NAME.toString().charAt(0)" 
					:color="getColor( item )" 
					:size="size"
					:image="item.PAGE_ICON_URL ? `url(${item.PAGE_ICON_URL })` : ''"
				></page-icon>
				<span class="title">{{ item.FOLDER_NAME }}</span>
			</a>
		</div>
	</div>
</template>
<script>
import { mapState } from "vuex";
import PageIcon from "./PageIcon.vue";

export default {
	components: {
		PageIcon
	},
	props: {
		currentSection : {
				type: Number,
				default: 0
		},
		showHomeSection : {
				type: Boolean,
				default: true
		},
		size: {
			type: String,
			default: 'md'
		},
		course: {
			type: Object,
			default: () => {},
		},
		menu: {
			type: Array,
			default: () => [],
		},
		courseContent: {
			type: Object,
			default: () => {},
		},
	},
	data() {
      return {
		   mediaPath : '/CommunityWebPortal/_app/includes/static/images/profiles/',
		   classPagePath : '/cwp/studentClassPage'
      }
    },
    computed: {
			isClassHome() {
					return this.currentSection === 0;
			},
			homeIconProps : function() {
				let current = { "size" : this.size };
				if(this.courseContent && !!this.courseContent.PAGE_ICON_URL){
					current.image = `url(${this.courseContent.PAGE_ICON_URL})`;
				}
				else if( this.course.TEACHER_IMAGE ){
						current.image = 'url(' + this.mediaPath + this.course.TEACHER_IMAGE + ')';
				} else {
						current.image = 'url(' + this.mediaPath + 'no-staff-image.png )';
				}
				return current;
			}
	 },
	methods : {
		getColor( item ) {
			return item.PAGE_ICON_COLOR;
		},
		goToSection(folderId){
			this.$router.push({ name: 'ClassPageSection', params: { courseSectionGUID: this.$route.params.courseSectionGUID, folderId: folderId } });
		},
		goToHome(){
			this.$router.push({ name: 'ClassPageHome', params: { courseSectionGUID: this.$route.params.courseSectionGUID } });
		}
	}
}
</script>
